<template id="resetPwSuccess">
  <div class="container float-page">
    <!-- Float Box -->
    <div class="float-box">
      <div class="card">
        <!-- Float Card Body -->
        <div class="card-body float-card-body">
          <h1 class="mb-3">{{ $t('Customer.resetPwSuccess.msg') }}</h1>
          <p class="float-box-msg mb-2">{{ $t('Customer.resetPwSuccess.msg1') }}</p>
          <el-button
            type="primary"
            class="btn btn-block btn-primary btn-lg"
            @click="toLogin()"
          >
            {{ $t('Customer.resetPwSuccess.msg2') }}
          </el-button>
        </div>
        <!-- /.float-card-body -->
      </div>
    </div>
    <!-- /.float-box -->
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  created() {
    this.$store.dispatch("updateCurrentIndex", 0);
  },
  methods: {
    toLogin() {
      this.$router.push({ name: "customerLogin" });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Customer/resetPwSuccess.vue